module.exports = __webpack_public_path__ + "static/since1992-0c1328301f2fec8bbe92add82fd05d48.jpg";